module.exports = __webpack_public_path__ + "static/media/closegroup.7ef832d7.svg";